module.exports = __webpack_public_path__ + "static/media/2 6 Ordkjedetest-Feil-hus-grei.b96d7fba.mp3";